import { useEffect, useState } from "react";
import {
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  NativeSelect,
  OutlinedInput,
  Select,
} from "@mui/material";

export default function FormikSelectField({
  id,
  label,
  handleChange,
  handleBlur,
  value,
  error,
  options,
  fullWidth,
  helperText,
  sx,
  touched,
  inputSx,
  size,
  ...otherProps
}) {
  const [isTouched, setIsTouched] = useState(false);

  useEffect(() => {
    if (touched === undefined) {
      setIsTouched(true);
    } else {
      setIsTouched(!!touched);
    }
  }, [touched]);

  return (
    <FormControl
      error={isTouched && !!error}
      fullWidth={fullWidth}
      sx={{ ...sx }}
      size={size != null ? `${size}` : null}
    >
      <InputLabel htmlFor={id}>{label}</InputLabel>
      <NativeSelect
        label={label}
        value={value}
        onChange={handleChange}
        input={<OutlinedInput/>}
        onBlur={handleBlur}
        id={id}
        sx={{ ...inputSx }}
        {...otherProps}
      >
        {options &&
          options.map((option) => (
            <option
              key={id + "-" + option.key}
              value={option.key}
              selected={!!option.default}
            >
              {option.label}
            </option>
          ))}
      </NativeSelect>
      {(helperText || (isTouched && error)) && (
        <FormHelperText>{error ? error : helperText}</FormHelperText>
      )}
    </FormControl>
  );
}
